(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["colecciones"] && !Shopify.designMode) return;
  try {
    
  theme.IndexSections = (function() {
  function IndexSections(container) {
    this.$container = $(container);
    this.namespace = '.index-sections';

    this.initSection(this.$container);
  }

  IndexSections.prototype.initSection = function($section) {
    var sectionId = $section.data('section-id');
    var section = new theme.IndexSection($section);

    theme.sections[sectionId] = section;

    this.initBlocks($section, section);
  };

  IndexSections.prototype.initBlocks = function($section, section) {
    var $blocks = $section.find('[data-block-type="card"]');
    $blocks.each(function() {
      var $block = $(this);
      var blockId = $block.data('block-id');
      var block = new theme.IndexBlock($block, section);

      section.blocks[blockId] = block;
    });
  };

  return IndexSections;
})();

  } catch(e) { console.error(e); }
})();
})();
